import React, { useState } from "react";
import { connect } from "react-redux";
import Modal from "../modal/Modal";
import { BA_CBS_ROLE, hasRoles } from "../../utils/roles";

import "./BenchmarkUploadModal.css";
import { FlagBenchmark } from "./Benchmark.components";
import { featureEnumerator } from "./Benchmark.functions";
import PropTypes from "prop-types";

export function ModalBenchmarkInfoFlag(prop) {
  const { selectedBenchmarks, setBenchmarking } = prop;
  const { user } = prop.auth;

  const [modal, setModal] = useState(false);
  const [feature, setFeature] = useState("");

  if (!hasRoles(user.roles, BA_CBS_ROLE)) {
    return null;
  }

  return (
    <div>
      <Modal
        // Modal Props
        title={getModalTitle(feature)}
        Component={FlagBenchmark}
        modal={modal}
        setModal={setModal}
        // Component Props
        setBenchmarking={setBenchmarking}
        selectedBenchmarks={selectedBenchmarks}
        setShow={setModal}
        feature={feature}
      />

      <BenchmarkViewConfigButtons
        title="Edit Privacy"
        featureEnumerator={featureEnumerator.SENSITIVITY}
        setFeature={setFeature}
        setModal={setModal}
      />
      <BenchmarkViewConfigButtons
        title="Edit Company"
        featureEnumerator={featureEnumerator.COMPANY}
        setFeature={setFeature}
        setModal={setModal}
      />
      <BenchmarkViewConfigButtons
        title="Edit Coordinates"
        featureEnumerator={featureEnumerator.COORDINATES}
        setFeature={setFeature}
        setModal={setModal}
      />
    </div>
  );
}
function getModalTitle(feature) {
  switch (feature) {
    case featureEnumerator.SENSITIVITY:
      return "Information Flagging";
    case featureEnumerator.COMPANY:
      return "Set Company";
    case featureEnumerator.COORDINATES:
      return "Set Project Coordinates";
    default:
      return "Modal";
  }
}
/// props validation | SQ(javascript:S6774)
BenchmarkViewConfigButtons.propTypes = {
  title: PropTypes.string,
  featureEnumerator: PropTypes.number,
  setModal: PropTypes.func,
  setFeature: PropTypes.func,
};

function BenchmarkViewConfigButtons(props) {
  const { featureEnumerator, title, setFeature, setModal } = props;
  return (
    <button
      className="general-modal-button benchmark-modal-button"
      onClick={() => {
        setFeature(featureEnumerator);
        setModal(true);
      }}
      title={title}
    >
      {title}
    </button>
  );
}

export default connect((state) => ({
  auth: state.auth,
}))(ModalBenchmarkInfoFlag);
